import { GeoLocality, GeoPosition } from '../..';

import { CreateGroupDto } from '@smatchy/sdk';

export class CreateGroupAction {
  static readonly type = '[CreateGroup] CreateGroupAction';
}

export class SetTitleCreateGroupAction {
  static readonly type = '[CreateGroup] SetTitleCreateGroupAction';

  constructor(public payload: string) {}
}

export class SetBackgroundImgCreateGroupAction {
  static readonly type = '[CreateGroup] SetBackgroundImgCreateGroupAction';

  constructor(public payload: string) {}
}

export class SetGroupDescriptionCreateGroupAction {
  static readonly type = '[CreateGroup] SetGroupDescriptionCreateGroupAction';

  constructor(public payload: string) {}
}

export class SetWebsiteUrlCreateGroupAction {
  static readonly type = '[CreateGroup] SetWebsiteUrlCreateGroupAction';

  constructor(public payload: string) {}
}

export class SetHandiFriendlyCreateGroupAction {
  static readonly type = '[CreateGroup] SetHandiFriendlyCreateGroupAction';

  constructor(public payload: boolean) {}
}

export class SetGroupLocationCreateGroupAction {
  static readonly type = '[CreateGroup] SetGroupLocationCreateGroupAction';

  constructor(
    public payload: {
      locality: GeoLocality;
      position: GeoPosition;
    },
  ) {}
}

export class SetPrivacyCreateGroupAction {
  static readonly type = '[CreateGroup] SetPrivacyCreateGroupAction';

  constructor(public payload: CreateGroupDto.PrivacyEnum) {}
}

export class SetRightCreateActivityCreateGroupAction {
  static readonly type = '[CreateGroup] SetRightCreateActivityCreateGroupAction';

  constructor(public payload: CreateGroupDto.RightCreateActivityEnum) {}
}

export class SelectSportIdCreateGroupAction {
  static readonly type = '[CreateGroup] SelectSportIdCreateGroupAction';

  /**
   * SMA-99. `sportIds` is optional so that the single-sport callers that existed
   * before it keep compiling and keep meaning what they meant: one sport. The
   * state fills the list from `sportId` when it is absent.
   */
  constructor(public payload: { sportId: string; sportKeyId: string; sportIds?: string[] }) {}
}

export class SetParentGroupIdCreateGroupAction {
  static readonly type = '[CreateGroup] SetParentGroupIdCreateGroupAction';

  constructor(public payload: string) {}
}

export class SetActivitySharingCreateGroupAction {
  static readonly type = '[CreateGroup] SetActivitySharingCreateGroupAction';

  constructor(public payload: boolean) {}
}

export class ResetCreateGroupStateAction {
  static readonly type = '[CreateGroup] ResetCreateGroupStateAction';
}
